import Navbar from "../../components/Navbar/Navbar";
import Table from "../../components/TableConstructor";
import Cabecalho from "../../components/Cabecalho";
import styles from "./styles.module.css";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import getEditais from "../../services/getEditais";
import RowColaboracoes from "../../components/TableConstructor/Row/RowColaboracoes";

type Edital = {
  id: number;
  titulo: string;
  descricao: string;
  link: string;
  inicio: Date;
  fim: Date;
};

function Editais() {
  const [listaEditais, setListaEditais] = useState<Edital[]>([]);
  const { token } = useContext(UserContext);

  useEffect(() => {
    const carregarDadosEditais = async () => {
      try {
        const editais = await getEditais(token);
        const listaDeEditais: Edital[] = [];
        for (let i = 0; i < editais.length; i++) {
          listaDeEditais.push({
            id: editais[i].id,
            titulo: editais[i].titulo,
            descricao: editais[i].descricao,
            link: editais[i].link_pdf,
            inicio: editais[i].data_lancamento,
            fim: editais[i].data_encerramento,
          });
        }
        setListaEditais(listaDeEditais);
      } catch (error) {
        console.error("Dados editais:", error);
      }
    };
    carregarDadosEditais();
  }, []);

  return (
    <div className={styles.page}>
      <Navbar activeIndex={2} />
      <section>
        <Cabecalho title="Editais de Colaboração" icon="hands" />
        <main>
          <div className={styles.container}>
            <h3>Editais criados</h3>
            <div>
              <Table
                listTitle={["Titulo", "Descrição", "Duração", ""]}
                styleList={[0, 0, 1]}
              >
                {listaEditais.length > 0 &&
                  listaEditais.map((edital, index) => (
                    <RowColaboracoes
                      titulo={edital.titulo}
                      descricao={edital.descricao}
                      inicio={edital.inicio}
                      fim={edital.fim}
                      id={edital.id}
                      key={index}
                    />
                  ))}
              </Table>
            </div>
          </div>
        </main>
      </section>
    </div>
  );
}

export default Editais;
